var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 14,
    fill: "none",
    viewBox: "0 0 13 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.5.5A6.5 6.5 0 1 0 13 7 6.52 6.52 0 0 0 6.5.5m0 11.375A4.875 4.875 0 1 1 11.375 7 4.89 4.89 0 0 1 6.5 11.875"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.906 6.188h-.812a.406.406 0 0 0-.407.406v3.25c0 .224.182.406.407.406h.812a.406.406 0 0 0 .407-.406v-3.25a.406.406 0 0 0-.407-.407M6.5 5.375a.813.813 0 1 0 0-1.625.813.813 0 0 0 0 1.625"
  })));
};
export default SvgInfo;